module.exports = __webpack_public_path__ + "img/full0-min.f45ee847.png";